/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

import axios from 'axios'

export async function getSitesData () {
  let sitesData

  try {
    const response = await axios.get('/sites.json')
    sitesData = response.data
  } catch (e) {
    console.debug(e)
  }

  return sitesData
}
